import styled, { css, keyframes } from 'styled-components';
import ChatList from './ChatList';
import { colorSchema } from 'utils/style';

const loadingKeyframes = keyframes`
  100% {
    transform: translateX(100%);
  }
`;

const loadingKeyframesRule = css`
  ${loadingKeyframes} 1.5s infinite;
`;

export default styled(ChatList)`
  .chat-list {
    display: flex;

    &__container {
      background: ${colorSchema('white')};
      box-shadow: 0 2px 7px 1px rgba(0, 0, 0, 0.07);
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      height: 90%;
      margin: 1.6rem;
      margin-top: -1.5rem;
      position: relative;
    }

    &__title {
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.19);
      margin: 0;
      padding: 1.6rem;
    }

    &__button {
      height: 48px;
      width: 272px;
    }

    &__footer {
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.02) 1%,
        rgba(255, 255, 255, 1) 36%,
        rgba(255, 255, 255, 1) 59%
      );
      border-radius: 0 0 8px 8px;
      bottom: 0;
      display: flex;
      justify-content: center;
      padding: 1.6rem 1.6rem 3.6rem 1.6rem;
      position: absolute;
      width: 100%;
    }

    &__error {
      display: block;
      color: ${colorSchema('error900')};
      text-align: center;
    }

    &__empty {
      align-items: center;
      display: flex;
      flex-direction: column;
      height: 100%;
      padding: 2rem 1rem 0 1rem;
    }

    &__empty-image {
      margin-bottom: 1.6rem;
      width: 247px;
    }

    &__empty-title {
      color: ${colorSchema('grey700')};
      font-size: 1.5rem;
      font-weight: bold;
      margin-bottom: 1rem;
      text-align: center;
    }

    &__empty-subtitle {
      color: ${colorSchema('grey700')};
      font-size: 1.5rem;
      margin-bottom: 2rem;
      text-align: center;
    }

    &__conversation {
      border-bottom: 1px solid ${colorSchema('grey100')};
      border-top: 1px solid ${colorSchema('grey100')};
      cursor: pointer;
      display: flex;
      flex-direction: column;
      padding: 1rem 0;

      &--loading {
        height: 50px;
        position: relative;
        opacity: 0.5;
        padding: 0;

        &:after {
          display: block;
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          transform: translateX(-100%);
          background: linear-gradient(
            90deg,
            transparent,
            rgba(0, 0, 0, 0.1),
            transparent
          );
          animation: ${loadingKeyframesRule};
        }
      }
    }

    &__conversation-list {
      overflow-y: scroll;
      overflow-x: hidden;
      padding: 0.8rem 1.6rem;

      &:after {
        content: '';
        display: block;
        height: 91px;
        width: 100%;
      }
    }

    &__conversation-header {
      margin-bottom: 0.8rem;
    }

    &__conversation-date {
      color: ${colorSchema('grey900')};
      font-size: 1.5rem;
      font-weight: 500;
    }

    &__conversation-separator {
      font-size: 1.4rem;
      color: ${colorSchema('grey700')};
    }

    &__conversation-id {
      font-size: 1.4rem;
      color: ${colorSchema('grey700')};
    }

    &__conversation-body {
      display: flex;
      justify-content: space-between;
    }

    &__conversation-badge {
      align-items: center;
      background-color: ${colorSchema('white')};
      border: 5px solid ${colorSchema('accent700')};
      border-radius: 50%;
      color: ${colorSchema('white')};
      display: flex;
      font-size: 1.2rem;
      height: 15px;
      justify-content: center;
      width: 15px;
    }

    &__conversation-title {
      color: ${colorSchema('grey900')};
      font-size: 1.5rem;
      font-weight: bold;
      margin-bottom: 0.8rem;
    }

    &__conversation-footer {
      align-items: center;
      display: flex;
      justify-content: space-between;
    }

    &__conversation-author {
      color: ${colorSchema('grey700')};
      font-size: 1.4rem;
    }

    &__conversation-message-container {
      display: flex;
      width: 60%;
    }

    &__conversation-message {
      color: ${colorSchema('grey700')};
      font-size: 1.4rem;
      margin-left: 0.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &--unread {
        font-weight: bold;
      }
    }

    &__conversation-time {
      color: ${colorSchema('grey500')};
      font-size: 1.2rem;
    }
  }
`;
